import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";

class TemplatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    document.title = "Order Analytics | QikTruck";
  }

  render() {
    return (
      <React.Fragment>
        
        <section className="section mt-5 pt-4">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10}>
                <Card>
                  <CardHeader>
                    <h4 className="mb-0">Order Analytics</h4>
                  </CardHeader>
                  <CardBody>
                    <p>Track and analyze your order statistics and performance metrics.</p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default TemplatePage; 